import API from '../../../../api/baseUrl';
import { getTokens } from '../../../../auth/AuthState';
import { useState } from 'react';
import { getClinicianProfileBasic } from '../../../../store/ai2';
import { useDispatch, useSelector } from 'react-redux';

export const useCreateTeam = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);

  const postCreateTeam = async (createTeamPayload) => {
    setIsLoading(true);
    try {
      const { id: authorization_token } = await getTokens();

      let options = {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authorization_token,
        },
      };
      const payload = {
        teamName: createTeamPayload.team_name,
        hospitalId: createTeamPayload.hospital_id,
        staffIds: createTeamPayload.staff_ids,
        tenancyId: selectedTenancy.tenancy_id,
      };
      const result = await API.post(`createTeam`, { ...payload }, options);
      const getTaskData = await getClinicianProfileBasic();
      await dispatch(getTaskData);
      return result;
    } catch (error) {
      console.error('An error occurred during create team', error);
      setErrorMessage(
        error?.response?.data?.message || 'Unknown error in create team',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postCreateTeam,
    errorMessage,
    isLoading,
  };
};
